import { render, staticRenderFns } from "./LimitGroupList.vue?vue&type=template&id=1855f895&scoped=true"
import script from "./LimitGroupList.vue?vue&type=script&lang=js"
export * from "./LimitGroupList.vue?vue&type=script&lang=js"
import style0 from "./LimitGroupList.vue?vue&type=style&index=0&id=1855f895&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855f895",
  null
  
)

export default component.exports